import { useEffect, useRef, useState } from 'react';
import WebApp from '@twa-dev/sdk';

interface Props {
  onBack: () => void;
}

const PRESETS = [30, 60, 90, 120, 180];

export function RestTimer({ onBack }: Props) {
  const [duration, setDuration] = useState(90);
  const [remaining, setRemaining] = useState(90);
  const [running, setRunning] = useState(false);
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (!running) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      return;
    }
    intervalRef.current = window.setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          setRunning(false);
          WebApp.HapticFeedback?.notificationOccurred?.('success');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [running]);

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  const timeText = `${minutes}:${String(seconds).padStart(2, '0')}`;
  const progress = duration > 0 ? ((duration - remaining) / duration) * 100 : 0;

  function pickPreset(secs: number) {
    setDuration(secs);
    setRemaining(secs);
    setRunning(false);
    WebApp.HapticFeedback?.selectionChanged?.();
  }

  function toggle() {
    if (remaining === 0) {
      setRemaining(duration);
    }
    setRunning((r) => !r);
    WebApp.HapticFeedback?.impactOccurred?.('light');
  }

  function reset() {
    setRunning(false);
    setRemaining(duration);
    WebApp.HapticFeedback?.impactOccurred?.('medium');
  }

  return (
    <div className="app">
      <button className="back-link" onClick={onBack}>← 홈</button>
      <h1>⏱️ 쉬는 시간</h1>

      <div className="timer">
        <div className="time">{timeText}</div>
        <div className="progress">
          <div className="progress-bar" style={{ width: `${progress}%` }} />
        </div>

        <div className="button-row" style={{ marginBottom: 16 }}>
          {PRESETS.map((p) => (
            <button
              key={p}
              className={`btn ${p === duration ? '' : 'btn-secondary'}`}
              onClick={() => pickPreset(p)}
              style={{ fontSize: 13, padding: 10 }}
            >
              {p < 60 ? `${p}s` : `${p / 60}m`}
            </button>
          ))}
        </div>

        <div className="button-row">
          <button className="btn" onClick={toggle}>
            {running ? '⏸ 일시정지' : remaining === 0 ? '🔁 재시작' : '▶ 시작'}
          </button>
          <button className="btn btn-secondary" onClick={reset}>
            초기화
          </button>
        </div>

        {remaining === 0 && (
          <p style={{ marginTop: 24, color: 'var(--tg-link)', fontWeight: 600 }}>
            ✅ 휴식 끝. 다음 세트 시작!
          </p>
        )}
      </div>
    </div>
  );
}
